export default __webpack_public_path__ + "static/monikan-14142e2f96f8e2cbd65cd65b42cbd25e.jpg";